export const XENDIT = 'xendit';
export const STRIPE = 'stripe';